/**
 * テーブル
 * Highlight Cells
 */
{
  /**
   * [mdss_flg description]
   * @type {Number}
   */
  let mdss_flg = 0;

  /**
   * ターゲットとなるjQueryオブジェクト
   * @type {object}
   */
  const overcells = $('.table-hover-cell, .table-hover-cell--pointer').find('td');

  /**
   * hover クラス名
   * @type {String}
   */
  const hoverClass = 'hover';

  /**
   * 現在の行のtd
   * @type {Object}
   */
  let current_r;

  /**
   * 現在の列のtd
   * @type {Object}
   */
  let current_c;

  overcells.hover(
    function() {
      if(mdss_flg != 1) {
        let $this = $(this);
        (current_r = $this.parent().children("table td")).addClass(hoverClass);
        (current_c = overcells.filter(":nth-child("+ (current_r.index($this)+1) +")")).addClass(hoverClass);
      }
    },
    function() {
      if(mdss_flg != 1) {
        current_r.removeClass(hoverClass);
        current_c.removeClass(hoverClass);
      }
    }
  );
}
